import axios from 'axios';
import {
  FINIX_MERCHANT_ID,
  FINIX_APP_ID,
  FINIX_ENV,
  GOOGLE_MERCHANT_ID,
  GOOGLE_PAY_ENVIRONMENT,
  APPLE_MERCHANT_ID_FILE,
} from '../config/paymentConfig';
import { API_ENDPOINTS } from '../config/apiConfig';

export type FinixPaymentType = 'CARD' | 'GOOGLE_PAY' | 'APPLE_PAY';

export interface TipPaymentPayload {
  token: string;
  tip: number;
  merchantId?: string;
  sessionKey: string;
  type: FinixPaymentType;
  companyName: string;
  appointmentId: number | string;
  idempotencyKey: string;
}

export interface LegacyFinixTipPayload {
  AppointmentID: number;
  CompanyName: string;
  IdempotencyKey?: string;
  MerchantID: string;
  SessionKey: string;
  Tip: number;
  Token: string;
  Type: FinixPaymentType;
}

export function toLegacyFinixTipPayload(payload: TipPaymentPayload): LegacyFinixTipPayload {
  return {
    AppointmentID: Number(payload.appointmentId),
    CompanyName: payload.companyName,
    IdempotencyKey: payload.idempotencyKey,
    MerchantID: payload.merchantId || FINIX_MERCHANT_ID,
    SessionKey: payload.sessionKey,
    Tip: payload.tip,
    Token: payload.token,
    Type: payload.type,
  };
}

export async function submitTipPayment(payload: TipPaymentPayload) {
  return axios.post(API_ENDPOINTS.PAYMENT.TIP_SUBMIT(), toLegacyFinixTipPayload(payload));
}

export interface ValidateFinixMerchantPayload {
  fieldName?: string;
  merchantID: string;
  validationURL: string;
}

export async function validateFinixMerchant(payload: ValidateFinixMerchantPayload) {
  const response = await axios.post('/api/frontend/v1/finix/validate-merchant', payload);
  return response.data;
}

// Export config for use in payment UI if needed
export const paymentConfig = {
  FINIX_MERCHANT_ID,
  FINIX_APP_ID,
  FINIX_ENV,
  GOOGLE_MERCHANT_ID,
  GOOGLE_PAY_ENVIRONMENT,
  APPLE_MERCHANT_ID_FILE,
}; 
